module.exports = __webpack_public_path__ + "img/exporter_Une_Famille.48382b0f.png";